/**
 * 新版本商品详情页面
 * 2023年07月14日
 */

$(function () {
  const nt_js_cart = $('.nt_js_new_cart'),
    cartUrl = t_cart_url,
    cartAddUrl = t_cartadd_url + '.js',
    $ld = $('#ld_cl_bar'),
    $ld_cart = $('.ld_cart_bar'),
    cartChangeUrl = t_cartchange_url + '.js',
    body = $('body');

  init();

  /**
   * 初始化方法
   */
  function init() {
    // 添加相关事件
    ajaxchangeItem();
    // 初始化
    $('.cart_jsccount').html(0);
    // 获取购物车数据
    getCartList().then(function (res) {
      let cId = [];
      gCart = res;
      // 添加预测
      for (let i = 0; i < res.items.length; i++) {
        cId.push(res.items[i].product_id)
      }
      // 去掉重复的id
      const maxNum = 12;
      cId = [...new Set(cId)];
      let num = Math.floor(maxNum / cId.length);
      // 空的购物车
      if(cId.length < 1) {
        $('.product-recommendations').hide();
      } else {
        for (let i = 0; i < cId.length; i++) {
          let pid = cId[i];
          cartRecommendations(pid, 3, num);
        }
        $('.product-recommendations').show();
      }
      // 更新购物车数据
      handleCartData(res);
      // 移出快捷支付按钮。只保留paypal
      $('.dynamic-checkout__content .Jk692hbroeK5lg6b_t4v ul li').not('li:eq(1)').remove();
      setCartPrSwiper('#cart_recommendations');
      setTimeout(function(){
        quickShop();
      }, 1000)

    }).catch(error => {
      console.error(`无法获取产品列表：${error}`);
    });

    // 你可能喜欢
    recently_viewed($('#recently_wrap_cart'))
    // recently_wrap_cart
    setCartPrSwiper('#recently_wrap_cart');

    // 使用优惠劵
    $('.cart-promo').on('click', '.j_btn_apply', function (e) {
      const code = $('.cart-promo .promo-code').val();
      if (!code) {
        return;
      }
      // 应用code
      applyDiscount(code);
      $(this).addClass('active').html('<span class="loader"></span>');
    });
    // 优惠code 输入事件
    $('.cart-promo').on('focus', '.promo-code', function (e) {
      $('.cart-promo .j_btn_apply').removeClass('active')
    });


    // 取消优惠劵使用
    $('.cart-promo').on('click', '.promo-list .cancel', function (e) {
      clearDiscount();
      $('.j_btn_apply').removeClass('active');
    });

    // 会员积分展示
    $('.summary-info').on('click', '.j-member-down', function (e) {
      $(this).toggleClass('active');
      $('.summary-info .member .tips').slideToggle("normal");
    });

    /**
     * 浏览器滚动事件
     */
    // 获取原始的坐标
    const defOffest = $('.right-order-summary').offset();
    const defWidth = $('.right-order-summary').width();
    if (isMobile()) {
      $('.js_cart_item .p_cart_qty_box').remove();
    } else {
      $('.js_cart_item .m_cart_qty_box').remove();
      // pc端执行
      $(window).scroll(function () {
        //滚动的高度
        var scrollTop = $(this).scrollTop();
        let top = $('.main-cart .right-order-summary').css('top');
        top = top.substr(0, top.length - 2);
        if (scrollTop > 60) {
          if (scrollTop > $('body').height() - $("#nt_footer").height() - $(".right-order-summary .summary-info").height() - 60) {
            $('.main-cart .right-order-summary').css({
              top: 'initial',
              bottom: '20px',
              left: defOffest.left,
              position: 'absolute'
            });
          } else {
            $('.main-cart .right-order-summary').css({
              top: 20,
              left: defOffest.left,
              width: defWidth + 'px',
              position: 'fixed'
            });
            // $('.main-cart .right-order-summary').show();
          }
        } else {
          $('.main-cart .right-order-summary').css({
            top: 'initial',
            left: defOffest.left,
            position: 'absolute',
            width: defWidth + 'px',
            bottom: 'initial',
          });
        }
      })
    }

  }

  /**
   * 生成产品推荐-轮播
   */
  function setCartPrSwiper(name) {
    var _swiper = new Swiper(name, {
      slidesPerView: isMobile() ? 2 : 3,
      spaceBetween: isMobile() ? 20 : 30,
      slidesPerGroup: isMobile() ? 2 : 3,
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination-ranked',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 8 * 1000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
    });
  }


  async function getCartList() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
        throw new Error(`HTTP 请求错误：${response.status}`);
      }
      const json = await response.json();
      return json;
    }
    catch (error) {
      console.error(`无法获取产品列表：${error}`);
    }
  }

  function ajaxchangeItem() {
    if (body.hasClass('min_cqty_1')) {
      nt_js_cart.on('keyup', '.qty_cart_js', function (e) {
        var _this = $(this),
          prev = _this.data('val'),
          qty = _this.val() || 1,
          min = _this.attr('min') || 0;

        if (parseInt(qty) < parseInt(min)) {
          _this.data('val', $(this).val());
          _this.val(prev);
        }
      });
    }

    nt_js_cart.on('focusin', '.qty_cart_js', function () {
      $(this).data('val', $(this).val());
    }).on('change', '.qty_cart_js', function (e) {
      var _this = $(this),
        _item = _this.closest('.js_cart_item'),
        _frm = _this.closest('form.nt_js_cart'),
        line = _this.parents(".js_cart_item").index() + 1,
        // vid = _this.data('id'),
        //prev = _this.data('val'),
        qty = _this.val() || 1,
        max = _this.attr('max') || 9999;

      _this.parent().find('.minus').removeClass(function (index, css) {
        return (css.match(/(^|\s)qty_\S+/g) || []).join(' ');
      }).addClass('qty_' + qty);

      //_this.parent().find('.minus').removeClass('qty_'+prev).addClass('qty_'+qty);

      if (parseInt(qty) > parseInt(max)) {
        qty = max; _this.val(qty);

        if (nt_settings.disOnlyStock) return;
        var txt = $('#js_we_stcl').text() || 'Not enough items available. Only [max] left.';
        geckoShopify.CreatNotices(txt.replace('[max]', max));
        return false;
      }
      if (_frm.hasClass('frm_cart_ajax_false')) return;

      nt_js_cart.addClass('ld_nt_cl');
      _item.find('.ld_cart_bar').addClass('on_star');
      changeItem(line, qty, _item, false);
    });

    nt_js_cart.on('click', '.js_cart_rem', function (e) {
      if ($(this).closest('form.nt_js_cart').hasClass('frm_cart_ajax_false')) return;
      e.preventDefault();
      //nt_js_cart.addClass('loading');
      var line = $(this).parents(".js_cart_item").index() + 1, qty = 0, _item = $(this).closest('.js_cart_item');
      nt_js_cart.addClass('ld_nt_cl');
      _item.find('.ld_cart_bar').addClass('on_star');
      changeItem(line, qty, _item ,false);
    });

    //   加减积分
    $(".js_cat_items").on('click', '.c_plus, .c_minus', function (e) {
      e.preventDefault();
      // Get values
      var _this = $(this),
        $qty = _this.closest('.quantity').find('.qty_cart_js'),
        currentVal = parseFloat($qty.val()),
        max = parseFloat($qty.attr('max')),
        min = parseFloat($qty.attr('min')),
        step = $qty.attr('step');

      // Format values
      if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
      if (max === '' || max === 'NaN') max = '';
      if (min === '' || min === 'NaN') min = 0;
      if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;
      // Change the value
      if (_this.is('.c_plus')) {
        if (max && (currentVal >= max)) {
          $qty.val(max);
          if (nt_settings.disOnlyStock) return;
          var txt = $('#js_we_stcl').text() || 'Not enough items available. Only [max] left.';
          geckoShopify.CreatNotices(txt.replace('[max]', max));
          return false;

        } else {
          $qty.val((currentVal + parseFloat(step)).toFixed(step.getDecimals()));
        }
      } else {
        if (min && (currentVal <= min)) {
          $qty.val(min);
        } else if (currentVal > 0) {
          $qty.val((currentVal - parseFloat(step)).toFixed(step.getDecimals()));
        }
      }
      
      // Trigger change event
      $qty.trigger('change');
    });

    // 替换添加购物车
    body.on('click', '.js_frm_new_cart', function (e) {
      e.preventDefault();
      var _this = $(this),
        frmId = _this.closest('form');

      if (_this.hasClass('disabled')) {
        geckoShopify.CreatNotices(PleaseChoosePrOptions);
        frmId.find('.nt_name_current:not(.user_choose_js)').css("color", "#ec0101");
        return false;
      }
      //geckoShopify.HideNotices();

      _this.addClass('loading');
      $ld.trigger("ld_bar_star");
      addItemFrom(frmId);
    });

  };

  /**
   * 更改购物车数量
   * @param {行号} line 
   * @param {数量} quantity 
   * @param {*} _item 
   */
  function changeItem(line, quantity, _item, blUp_items) {
    var request = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;'
      },
      body: JSON.stringify({
        line,
        quantity
      })
    };
    // 精度条
    function UpdateBarItem() {
      _item.find('.ld_cart_bar').addClass('on_end');
      setTimeout(function () {
        _item.find('.ld_cart_bar').attr('class', '').addClass('ld_cart_bar');
        nt_js_cart.removeClass('ld_nt_cl');
      }, 280);
    };
    fetch(cartChangeUrl, request)
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if(!cart?.total_price) {
          location.reload();
          return;
        }
        if (quantity == 0) {
          _item.slideUp("250", function () { $(this).remove(); });
        } else {
          var price = _item.find('.qty_cart_js').attr('data-price') * quantity;
          _item.find('.js_tt_price_it').html(geckoShopify.formatMoney(price));
        }
       
        if (blUp_items) {
          setTimeout(function(){
            $('html, body').animate({
              scrollTop: $('.cart-main-block').offset().top - 80
            }, 400);
            UpdateBarItem();
            location.reload();
          }, 2500)
        } else {
          onCartUpdate();
          UpdateBarItem();
        }
      })
      .catch(function (error) {
        // eslint-disable-next-line no-console
        console.log('cart change error: ' + error);
      });
  };

  function addItemFrom(form_id, _this) {
    var clicked_ed_js = $('.cart_ac_edit.clicked_ed_js');
    var edit_item = nt_settings.edit_item;
    // Start case js fetch
    function addFetchFrom(form_id, _this) {
      fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: serializet4(form_id[0])
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (line_item) {
          if (line_item.status && line_item.status !== 200) {
            var error = new Error(line_item.description);
            error.isFromServer = true;
            throw error;
          }
          //console.log(line_item.status,line_item);
          var id = 19041994;
          if (line_item.product_id != undefined) {
            id = line_item.product_id;
          } else if (line_item.items != undefined) {
            id = line_item.items[0].product_id;
          }
          // 刷新购物车列表
          $('html, body').animate({
            scrollTop: $('.cart-main-block').offset().top - 80
          }, 400);
          location.reload();
          // onCartUpdate();
          if (id != '19041994') {
            var el = $('.nt_stock_page[data-prid="' + id + '"]'),
              qty = line_item.quantity;
            geckoShopify.progressbarUpdateATC(el, qty);
          }
          body.trigger('CartUpdateSuccess');
          $ld.trigger("ld_bar_end");
        })
        .catch(function (error) {
          // eslint-disable-next-line no-console
          //console.log('addFetchFrom error: ',error);
          $('button[type=submit].loading').removeClass('loading');
          geckoShopify.onError2(error);
        });
    };

    if (clicked_ed_js.length > 0 && edit_item == '0') {

      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          line: clicked_ed_js.parents(".js_cart_item").index() + 1,
          quantity: 0
        })
      };

      fetch(cartChangeUrl, request)
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          $('.cart_jsccount').html(cart.item_count);
          clicked_ed_js.removeClass('clicked_ed_js');
          addFetchFrom(form_id, _this);
        })
        .catch(function (error) {
          // eslint-disable-next-line no-console
          console.log('Cart change error: ' + error);
        });

    } else {
      addFetchFrom(form_id, _this);
    }
    // End case js fetch
  };

  /**
   * 购物车 更新购物车数据
   * @param {} bl 
   * @param {*} blUp_items  是否只修改数量
   * @param {*} id 
   * @returns 
   */
  function onCartUpdate() {
    // 缺货的时候运行
    if ($('.reload_cart_js').length > 0) {
      location.reload();
      return false;
    }
    getCartList().then(function (res) {
      handleCartData(res);
    })
    // 更新购物车列表
  }

  /**
   * 处理整体购物车数据
   * @param {购物车对象} res 
   */
  function handleCartData(res) {
      // 更新数量
      var OldCartCount = $('.cart_jsccount').html(),
          CurrentCartCount = parseInt(res.item_count);
          console.log(CurrentCartCount);
      if (CurrentCartCount == 0) {
        // 判断购物车是否有商品
        $('.main-cart .left-cart').hide();
        $('.summary-info').attr('disabled', "disabled");
        $('.summary-info .js_add_ld').attr('disabled', "disabled");
        $('.main-cart .no-cart-block').show();
        $('.cart-promo').addClass('dn');
      } else {
        $('.main-cart .left-cart').show();
        $('.main-cart .no-cart-block').hide();
        $('.summary-info').removeAttr("disabled");
        $('.summary-info .js_add_ld').removeAttr("disabled");
        $('.cart-promo').removeClass('dn')
      }
      if (CurrentCartCount != OldCartCount) {
        $('.cart_jsccount').html(CurrentCartCount);
        // 更新总价格
        let total_price = res.total_price;

        // 是否有折扣价格
        // let discountArr = res.cart_level_discount_applications;
        // if (discountArr.length > 0){
        //   $('.dis-list .promo-code').find('p').text('-' + gformatMoney(res.total_discount));
        //   // 优惠券名称
        //   $('.summary-info .reduction-code__text').text(discountArr[0].title);
        //   // 更新单次价格
        //   $('.dis-list .sub-total').find('p').text(gformatMoney(res.original_total_price));
        //   $('.dis-list').show();
        //   $('.promo-list').show();
        // }else {
        //   $('.dis-list').hide();
        //   $('.promo-list').hide();
        // }
        // 更新总价格
        $('.j_total_price').text(gformatMoney(total_price));
        body.trigger('refresh_currency');
        if ($.magnificPopup.instance.isOpen) {
          $.magnificPopup.close();
        }
        // if (!blUp_items) {
          $('html, body').animate({
            scrollTop: $('.cart-main-block').offset().top - 80
          }, 400);
        // }
      }
  }

  /**
   * 取消优惠劵
   */
  function clearDiscount() {
    localStorage.removeItem("discountCode");
    $('.promo-list').hide();
    fetch("/discount/clear");
    // 从列表中取出第一个
    setTimeout(function () {
      $('.cart_jsccount').html(0);
      Cookies.remove('discount_code')
      let id = $('.js_cart_item:eq(0) .qty_cart_js').attr('data-id'),
      qty = $('.js_cart_item:eq(0) .qty_cart_js').val();
      // 更改数量发现可以刷新页面
      // 需要刷新右侧页面
      changeItem(id, qty, $('.js_cart_item:eq(0)'), true);
    }, 200)
  }

  /**
   *  使用优惠券方法
   * @param {code} code 
   */
  function applyDiscount(code) {
    fetch("/payments/config", { "method": "GET" })
      .then(function (response) { return response.json() })
      .then(function (data) {
        const checkout_json_url = '/wallets/checkouts/';
        authorization_token = btoa(data.paymentInstruments.accessToken)
        fetch('/cart.js', {}).then(function (res) { return res.json(); })
          .then(function (data) {
            let body = { "checkout": { "discount_code": code, "line_items": data.items, 'presentment_currency': Shopify.currency.active } }
            fetch(checkout_json_url, {
              "headers": {
                "accept": "*/*", "cache-control": "no-cache",
                "authorization": "Basic " + authorization_token,
                "content-type": "application/json, text/javascript",
                "pragma": "no-cache", "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
              },
              "referrerPolicy": "strict-origin-when-cross-origin",
              "method": "POST", "mode": "cors", "credentials": "include",
              "body": JSON.stringify(body)
            })
              .then(function (response) { return response.json() })
              .then(function (data) {
                if (data.checkout && data.checkout.applied_discounts.length > 0) {
                  let discountApplyUrl = "/discount/" + code + "?v=" + Date.now() + "&redirect=/checkout/";
                  fetch(discountApplyUrl, {}).then(function (res) {
                    var id = $('.js_cart_item:eq(0) .qty_cart_js').attr('data-id'),
                      qty = $('.js_cart_item:eq(0) .qty_cart_js').val();
                    // 更改数量发现可以刷新页面
                    setTimeout(function () {
                      $('.cart_jsccount').html(0);
                      changeItem(id, qty, $('.js_cart_item:eq(0)'), true);
                      $('.cart-promo .promo-code').val('');
                      $('.j_btn_apply').html($('.j_btn_apply').attr('name'));
                    }, 100)
                  });
                } else {
                  $('.j-error-prome').show().fadeOut(4000);
                  $('.j_btn_apply').removeClass('active').html($('.j_btn_apply').attr('name'));
                }
              }).finally(function (params) {
                console.log(params)
              });
          });
      });
  }

})

/**
 *  推荐产品方法
 * @param {推荐的产品} id 
 * @param {默认 3 } type 1
 * @returns String 推荐产品html
 */
var gPidArr = [];
function cartRecommendations(id, type, limit) {
  var _this = $('#cart_recommendations');
  if (_this.length == 0) return;
  var baseUrl = _this.data('baseurl');
  if (type == '3') {
    var url = baseUrl + '?section_id=cart-recommendations&product_id=' + id + '&limit=' + limit;
  } else {
    var url = baseUrl + '&section_id=cart-recommendations';
  }
  $.ajax({
    url: url,
    dataType: 'html',
    type: 'GET',
    success: function (section) {
      var recommendationsMarkup = $(section).html();
      var id = $(section).find('.js_cart_qs').attr('data-id');
      if (recommendationsMarkup.trim() !== '' && gPidArr.indexOf(id) < 0) {
        $(section).find('.swiper-slide').appendTo(_this.find('.swiper-wrapper'));
        gPidArr.push(id);
      }
    },
    error: function () {
      _this.hide();
    },
    complete: function () { }
  });
};


/**
 * 你访问过的商品
 * @param {} sl 
 * @returns 
 */
function recently_viewed(sl) {
  var el = sl || $('#recently_wrap');
  if (el.length == 0) return;

  var ls = localStorage.getItem('nt_recent'),
    id = (t_name == "product") ? el.data('id') : '19041994',
    get = el.data('get'),
    unpr = el.data('unpr'),
    limit = el.data('limit');

  if (ls != null) {
    var arrls = ls.split(','),
      index = arrls.indexOf(id);

    if (index > -1) {
      arrls = arrls.splice(0, limit + 1);
      arrls.splice(index, 1);
    } else {
      arrls = arrls.splice(0, limit);
    }

    if (arrls.length == 0) {
      el.slideUp();
      return false;
    }

    var arr_list = arrls.toString(),
      uri = arr_list.replace(/,/g, ' OR '),
      res = encodeURI(uri);
    $.ajax({
      url: get + '?view=cart_nathan&type=product&options[unavailable_products]=' + unpr + '&q=' + res,
      dataType: 'html',
      type: 'GET',
      success: function (section) {
        var recentlyMarkup = (designMode) ? $($(section)[2]).html() : $(section).html();
        try {
          recentlyMarkup.trim()
        }
        catch (err) {
          recentlyMarkup = $(section).html()
        }
        if (recentlyMarkup.trim() !== '') {
          //console.log(responsive);
          el.find('.swiper-wrapper').html(recentlyMarkup);
        }
      },
      error: function () {
        _this.hide();
      },
      complete: function () { }
    });

  } else {
    el.html('');
    $('.cart_recentlyViewed').hide();
    arrls = new Array();
  }
};

/**
 * 购物车变体更换产品
 * 添加购物车
 */
function quickShop() {
  var clicked_ed_js = 'clicked_ed_js',
    edit_item = nt_settings.edit_item,
    str_replace_atc = T4stt_str.replace_item_atc,
    str_replace_pre = T4stt_str.replace_item_pre;

  var txt_close = nt_settings.close;
  const body = $('body');

  // 添加编辑购物车
  body.on('click', '.js_cart_qs', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (designMode) return;
    //$.magnificPopup.close();
    var btn = $(this), res = null, ntid = btn.attr('data-id'), href = btn.attr('href');
    //console.log(ntid)
    if (sp_nt_storage) {
      res = sessionStorage.getItem('qs' + ntid)
    }
    if (res !== null) {
      btn.addClass('loading qs_opened ' + clicked_ed_js);
      if ($.magnificPopup.instance.isOpen) {
        $.magnificPopup.close();
        setTimeout(function () {
          quickshop_js(false, res, btn, ntid, href);
        }, $.magnificPopup.instance.st.removalDelay + 100);
      } else {
        quickshop_js(false, res, btn, ntid, href);
      }
    } else {
      //console.log(href)
      var a = (href.indexOf('?variant=') > -1 || href.indexOf('&variant=') > -1) ? '&' : '/?';
      let url = href + a + 'view=quick_shop_cart';
      console.log(url);
      $.ajax({
        beforeSend: function () {
          btn.addClass('loading ' + clicked_ed_js);
          //btn.addClass('loading qs_opened '+clicked_ed_js);
        },
        url: url,
        success: function (data) {
          if ($.magnificPopup.instance.isOpen) {
            $.magnificPopup.close();
            setTimeout(function () {
              quickshop_js(true, data, btn, ntid, href);
            }, $.magnificPopup.instance.st.removalDelay + 10);
          } else {
            quickshop_js(true, data, btn, ntid, href);
          }
        },
        complete: function () {
          $('.loader').remove();
          btn.removeClass('loading');
        }
      })
    }
    // return false; //for good measure
    // e.preventDefault();
    // e.stopPropagation();
  });

  var quickshop_js = function (bl, dt, btn, ntid, href) {
    $.magnificPopup.open({
      items: {
        src: '<div class="mfp-with-anim pp_qs" id="content_cart_quickview">' + dt + '</div>', // can be a HTML string, jQuery_T4NT object, or CSS selector
        type: 'inline'
      },
      tClose: txt_close,
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function () {
          this.st.mainClass = 'mfp-move-vertical';
        },
        open: function () {
          if (btn.hasClass('cart_ac_edit') && edit_item == '0') {
            $('#content_quickview.pp_qs .txt_add').text(str_replace_atc);
            $('#content_quickview.pp_qs .txt_pre').text(str_replace_pre);
          }
          btn.addClass('pp_t4_opended');
          var el = $('.nt_carousel_qs'), option = el.attr("data-flickity") || '{}';
          //console.log(option)
          el.flickity(JSON.parse(option));
          body.addClass('open_ntqs');

          if (sp_nt_storage && bl) { sessionStorage.setItem('qs' + ntid, dt) }
          //$('#content_quickview .entry-title a, #content_quickview .detail_link').attr("href",href);
          btn.removeClass('loading');

          geckoShopify.DropdownPicker();
          geckoShopify.review();
          if ($('#content_quickview .buy_qs_true').length > 0) {
            Shopify.PaymentButton.init();
          }
          if ($('#store_availability_qs').attr('data-has-only-default-variant') === 'true') {
            geckoShopify._updateStoreAvailabilityContent($('#store_availability_qs'), true, $('#store_availability_qs').attr('data-vid'));
          }
          $('#content_quickview .lazypreloadt4s.nt_pre_img').addClass('lazyloadt4s');

          if (!$('#ProductJson-template_qs').html()) {
            return;
          }

          var productJson = JSON.parse($('#ProductJson-template_qs').html()),
            incomingJson = JSON.parse($('#ProductJson-incoming_qs').html()),
            IdSelect = '#product-select_qs', NtId = '#nt_select_qs_', selector = '#cart-form_qs', callBackVariant = '#callBackVariant_qs', prefix = '_qs',
            i, variant, Arr_MD = [];

          productJson.ck_so_un = incomingJson.ck_so_un;
          productJson.ntsoldout = incomingJson.ntsoldout;
          productJson.unvariants = incomingJson.unvariants;
          productJson.remove_soldout = incomingJson.remove_soldout;
          productJson.size_avai = incomingJson.size_avai;
          productJson.tt_size_avai = incomingJson.tt_size_avai;

          for (i in incomingJson.variants) {
            variant = incomingJson.variants[i];
            productJson.variants[i].incoming = variant.incoming;
            productJson.variants[i].next_incoming_date = variant.next_incoming_date;
            productJson.variants[i].inventory_quantity = variant.inventory_quantity;
            Arr_MD.push(variant.mdid);
          }

          geckoShopify.Ntproduct_switch('.variations_form_qs', Arr_MD, productJson, selector, IdSelect, NtId, callBackVariant, prefix);
          if (nt_settings.pr_curent !== "1" || $('#cart-form_qs .is-selected-nt').length > 0) {
            $('#nt_select_qs_1 .is-selected-nt, #nt_select_qs_2 .is-selected-nt').addClass('is-selected').removeClass('is-selected-nt');
            $('#nt_select_qs_0 .is-selected-nt').click().removeClass('is-selected-nt');
            $('#nt_select_qs_1 .is-selected,#nt_select_qs_2 .is-selected').removeClass('is-selected').click();
          }
        },
        beforeClose: function () {
          if ($('.store_availabilities_modal.act_opened').length > 0) {
            $('.store_availabilities_modal .close_pp').trigger('click');
          }
        },
        close: function () {
          $('.' + clicked_ed_js).removeClass(clicked_ed_js);
          $('#content_quickview').empty();
          body.trigger('refresh_hreft4');
          //btn.removeClass('pp_t4_opended');
          btn.removeClass('pp_t4_opended qs_opened');
          body.removeClass('open_ntqs');
          geckoShopify.DropdownPicker();
        }
      },
    });
  };

};

// 添加格式化方法
if (!String.prototype.getDecimals) {
  String.prototype.getDecimals = function () {
    var num = this,
      match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
      return 0;
    }
    return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
  }
}

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
  function serializet4(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
            '=' +
            encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  };



 function gformatMoney(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || t_moneyFormat || '${{amount}}');

    var defaultOption = function(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }

    var formatWithDelimiters = function(number, precision, thousands, decimal) {
       precision = defaultOption(precision, 2);
       thousands = defaultOption(thousands, ',');
       decimal = defaultOption(decimal, '.');

       if (isNaN(number) || number == null) {
          return 0;
       };

       number = (number / 100.0).toFixed(precision);

       var parts = number.split('.');
       var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
       var cents = parts[1] ? (decimal + parts[1]) : '';

       return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
    }

    return formatString.replace(placeholderRegex, value);
 }